<template>
  <button
    :aria-expanded="isMenuOpen"
    aria-controls="mobile-menu"
    class="flex items-center justify-end"
    @click="toggleMenu"
  >
    <span v-if="!isMenuOpen" class="sr-only">Open menu</span>
    <span v-else class="sr-only">Close menu</span>

    <svg
      v-if="!isMenuOpen"
      xmlns="http://www.w3.org/2000/svg"
      class="h-8 w-8"
      viewBox="0 0 24 24"
      version="1.1"
      x="0px"
      y="0px"
    >
      <path
        fill="currentColor"
        d="M22.8,20H1.2C0.5,20,0,19.5,0,18.9s0.5-1.1,1.2-1.1h21.6c0.7,0,1.2,0.5,1.2,1.1S23.5,20,22.8,20z"
      ></path>
      <path
        fill="currentColor"
        d="M22.8,13.1H1.2C0.5,13.1,0,12.6,0,12s0.5-1.1,1.2-1.1h21.6c0.7,0,1.2,0.5,1.2,1.1S23.5,13.1,22.8,13.1z"
      ></path>
      <path
        fill="currentColor"
        d="M22.8,6.3H1.2C0.5,6.3,0,5.8,0,5.1S0.5,4,1.2,4h21.6C23.5,4,24,4.5,24,5.1S23.5,6.3,22.8,6.3z"
      ></path>
    </svg>
    <svg v-else class="h-8 w-8" x="0px" y="0px" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13.5,12L20,5.5c0.4-0.4,0.4-1.1,0-1.5c-0.4-0.4-1.1-0.4-1.5,0L12,10.5L5.5,4.1c-0.4-0.5-1-0.5-1.4,0
      c-0.4,0.5-0.4,1.1,0,1.5l6.4,6.4L4,18.5c-0.4,0.4-0.4,1.1,0,1.5c0.3,0.1,0.6,0.3,0.8,0.3s0.6-0.1,0.8-0.3l6.5-6.5l6.5,6.5
      c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.4-0.4,0.4-1.1,0-1.5L13.5,12z"
      ></path>
    </svg>
  </button>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from 'vue'

const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const updateMenuClass = () => {
  const mobileMenu = document.getElementById('mobile-menu')
  if (mobileMenu) {
    mobileMenu.classList.toggle('menu-open', isMenuOpen.value)
  }
  document.body.classList.toggle('overflow-hidden', isMenuOpen.value)
}

const handleResize = () => {
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches
  if (isDesktop && isMenuOpen.value) {
    isMenuOpen.value = false
    updateMenuClass()
  }
}

watch(isMenuOpen, updateMenuClass)

onMounted(() => {
  const mobileMenu = document.getElementById('mobile-menu')
  if (mobileMenu && mobileMenu.classList.contains('menu-open')) {
    isMenuOpen.value = true
  }

  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped></style>
